import { createRouter, createWebHistory } from "vue-router";
import Home from "@/components/Home.vue";
import ClientDetails from "@/components/ClientDetails.vue";
import Candidati from "@/components/Candidati.vue";
import CandidateDetails from "@/components/CandidateDetails.vue";
import UploadCV from "@/components/UploadCV.vue";
import Employees from "@/components/Employees.vue";
import EmployeeDetails from "@/components/EmployeeDetails.vue";
import EmployeeDetailsExtView from "@/components/EmployeeDetailsExtView.vue";
import EmployeeHolidays from "@/components/holiday/EmployeeHolidays.vue";
import HrDashboard from "@/components/HrDashboard.vue";
import ExternalDashboard from "@/components/ExternalDashboard.vue";
import users from "@/components/users.vue";
import me from "@/components/me.vue";
import NcrmBoard from "@/components/ncrm/NcrmBoard.vue";
import NcrmContacts from "@/components/ncrm/contacts/NcrmContacts.vue";
import NcrmCompanyDetails from "@/components/ncrm/NcrmCompanyDetails.vue";
import NcrmPersonDetails from "@/components/ncrm/NcrmPersonDetails.vue";
import NcrmActivities from "@/components/ncrm/NcrmActivities.vue";
import NcrmLeadsHome from "@/components/ncrm/leads/NcrmLeadsHome.vue";
import NcrmLeadBoard from "@/components/ncrm/leads/NcrmLeadBoard.vue";
import NcrmLeadDetails from "@/components/ncrm/leads/NcrmLeadDetails.vue";
import NcrmDealsHome from "@/components/ncrm/deals/NcrmDealsHome.vue";
import NcrmDealBoard from "@/components/ncrm/deals/NcrmDealBoard.vue";
import NcrmDealDetails from "@/components/ncrm/deals/NcrmDealDetails.vue";
import NcrmProducts from "@/components/ncrm/deals/NcrmProducts.vue";
import NcrmOnboardingHome from "@/components/ncrm/onboarding/NcrmOnboardingHome.vue";
import NcrmOnboardingBoard from "@/components/ncrm/onboarding/NcrmOnboardingBoard.vue";
import NcrmOnboardingDetails from "@/components/ncrm/onboarding/NcrmOnboardingDetails.vue";
import NcrmOnboardingTemplates from "@/components/ncrm/onboarding/NcrmOnboardingTemplates.vue";
import NcrmContractsHome from "@/components/ncrm/contracts/NcrmContractsHome.vue";
import NcrmContractDetails from "@/components/ncrm/contracts/NcrmContractDetails.vue";
import NcrmDataProtectionWorkspace from "@/components/ncrm/privacy/NcrmDataProtectionWorkspace.vue";
import PremiumFeatureRoute from "@/components/premium/PremiumFeatureRoute.vue";
import Recrutare from "@/components/Recrutare.vue";
import CD_Recrutare from "@/components/candidate/CD_recrutare.vue";
import RecrutareDetails from "@/components/RecrutareDetails.vue";
import UserRoles from "@/components/UserRoles.vue";
import NoCompanyContext from "@/components/NoCompanyContext.vue";
import { normalizeRoleKey, expandRoleAliases, resolveRedirectPath, DEFAULT_ROLE_KEYS } from "@/Utile/roleHelpers.mjs";
import { canAccessModule, readStoredLicenseSnapshot } from "@/Utile/licenseHelpers.mjs";
import { clearAuthStorage } from "@/Utile/authStorage.mjs";
import { isAuthSessionExpired, readAuthSession } from "@/Utile/authSession.mjs";
import adminRoutes from "./adminRoutes";
import publicAuthRoutes from "./publicAuthRoutes";

const VAC_ROLES = ["vacation-default", "vacation-user", "vacation-manager", "vacation-director", "vacation-hr"];
const CRM_ROLES = ["crm-default", "crm-admin", "crm-operator", "crm-caller"];
const AI_ROLES = ["ai-default"];
const NCRM_ROLES = ["crm-admin", "crm-operator"];
const NCRM_DATA_INTEGRATIONS_ROLES = [...NCRM_ROLES, "privacy-manager"];
// crm-default e rol legacy (vechiul /Crm). Noul CRM /ncrm NU îl suportă la backend
// (ACTIVITY_ROLES/CONTACTS_READ_ROLES/DEAL_LOOKUP_ROLES), deci NU îl punem pe board —
// l-ar lăsa pe o pagină plină de 403. Vezi roleHelpers (crm-default aterizează pe home).
const NCRM_BOARD_ROLES = [...NCRM_ROLES, "crm-caller", "caller"];
const NCRM_LEADS_ROLES = [...NCRM_ROLES, "crm-caller", "caller"];
const NCRM_ACTIVITIES_ROLES = [...NCRM_ROLES, "crm-caller", "caller"];
const NCRM_CONTACT_DETAILS_ROLES = [...NCRM_ROLES, "crm-caller", "caller"];
const NCRM_ONBOARDING_ROLES = [...NCRM_ROLES];
const NCRM_CONTRACTS_ROLES = [...NCRM_ROLES];
const NCRM_WORKFLOWS_ROLES = [...NCRM_ROLES];
const NCRM_MITP_WORKSPACE_LITERAL_ROLES = ["admin", "miridar"];
// Oglinda lui `hasRegistryAccess` din `backend/ncrm/privacy/access.js`: rolurile
// de conducere se potrivesc literal, operatorii prin alias. `useradmin-default`
// expandează la `admin`, dar backend-ul îl refuză, deci nu are voie să treacă.
const NCRM_DATA_PROTECTION_LITERAL_ROLES = ["admin", "miniadmin", "privacy-manager"];
const NCRM_DATA_PROTECTION_ROLES = ["crm-operator"];
const RECR_ROLES = ["recruiter-default", "recruiter-hr", "recruiter-viewer"];
const SUPER_ROLES = ["admin", "miniadmin", "useradmin-default"];
const isInternalDemoUiEnabled = process.env.NODE_ENV === "development";

const routes = [
  {
    path: "/Candidati",
    name: "Candidati",
    component: Candidati,
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, "vacation-hr", ...RECR_ROLES, ...CRM_ROLES],
    },
  },
  {
    path: "/EmployeeDetails/:id",
    name: "EmployeeDetails",
    component: EmployeeDetails,
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, ...VAC_ROLES],
    },
  },
  {
    path: "/EmployeeDetailsView/:id",
    name: "EmployeeDetailsExtView",
    component: EmployeeDetailsExtView,
    props: (route) => ({ employeeId: route.params.id }),
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, ...VAC_ROLES],
    },
  },
  {
    path: "/EmployeeHolidays",
    name: "EmployeeHolidays",
    component: EmployeeHolidays,
    props: (route) => ({ employeeId: route.query.id || route.params.id || null }),
    meta: {
      requiresAuth: true,
      roles: VAC_ROLES,
    },
  },
  {
    path: "/Companies/:companyId/employees",
    name: "CompanyEmployees",
    component: Employees,
    props: (route) => ({
      companyIdFilter: route.params.companyId ? Number(route.params.companyId) : null,
      showCompanySelect: false,
    }),
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, ...VAC_ROLES],
    },
  },
  {
    path: "/candidates/:id",
    name: "CandidateDetails",
    component: CandidateDetails,
    props: true,
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, "vacation-hr", ...RECR_ROLES, ...CRM_ROLES],
    },
  },
  {
    path: "/candidates/:id/recrutare",
    name: "CandidateRecruitment",
    component: CD_Recrutare,
    props: route => ({ candidateId: route.params.id }),
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, "vacation-hr", ...RECR_ROLES, ...CRM_ROLES],
    },
  },
  {
    path: "/UploadCV",
    name: "UploadCV",
    component: UploadCV,
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, "vacation-hr", ...RECR_ROLES, ...CRM_ROLES],
    },
  },

  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, ...VAC_ROLES, ...CRM_ROLES, ...AI_ROLES, ...RECR_ROLES],
    },
  },
  {
    path: "/hr-dashboard",
    name: "HrDashboard",
    component: HrDashboard,
    meta: {
      requiresAuth: true,
      roles: ["admin", "miniadmin", "vacation-hr"],
    },
  },
  {
    path: "/hr-dashboard/employeedetailshr",
    name: "HrDashboardEmployeeDetails",
    component: HrDashboard,
    meta: {
      requiresAuth: true,
      roles: ["admin", "miniadmin", "vacation-hr"],
    },
  },
  {
    path: "/dashboard",
    name: "ExternalDashboard",
    component: ExternalDashboard,
    meta: {
      requiresAuth: true,
      roles: VAC_ROLES,
    },
  },
  {
    path: "/users",
    name: "users",
    component: users,
    meta: {
      requiresAuth: true,
      roles: ["admin", "miniadmin", "useradmin-default"],
    },
  },
  {
    path: "/users/:id/roles",
    name: "UserRoles",
    component: UserRoles,
    props: true,
    meta: {
      requiresAuth: true,
      roles: ["admin", "miniadmin", "useradmin-default"],
    },
  },
  {
    path: "/me",
    name: "me",
    component: me,
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, ...VAC_ROLES, ...CRM_ROLES, ...AI_ROLES, ...RECR_ROLES],
    },
  },
  {
    path: "/ai-workspace",
    name: "AiWorkspace",
    component: PremiumFeatureRoute,
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, ...AI_ROLES],
    },
  },
  ...adminRoutes,
  {
    path: "/client/:id",
    name: "ClientDetails",
    component: ClientDetails,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...CRM_ROLES],
    },
  },
  {
    path: "/ncrm",
    name: "NcrmBoard",
    component: NcrmBoard,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_BOARD_ROLES],
    },
  },
  {
    path: "/mobile-hub",
    name: "MobileHub",
    component: () => import("@/components/mobile/MobileHub.vue"),
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_BOARD_ROLES],
    },
  },
  {
    path: "/ncrm/data-integrations",
    name: "NcrmDataIntegrations",
    component: PremiumFeatureRoute,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_DATA_INTEGRATIONS_ROLES],
      literalRoles: NCRM_MITP_WORKSPACE_LITERAL_ROLES,
      roleAccessMode: "any",
    },
  },
  {
    path: "/ncrm/data-integrations/:batchId",
    name: "NcrmImportDetails",
    component: PremiumFeatureRoute,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ROLES],
    },
  },
  {
    // Nu stă sub `PremiumFeatureRoute`: workspace-ul central nu are un entitlement
    // aprobat, iar enforcement-ul nu depinde oricum de el (`GDPR-031`).
    path: "/ncrm/data-protection",
    name: "NcrmDataProtection",
    component: NcrmDataProtectionWorkspace,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      literalRoles: NCRM_DATA_PROTECTION_LITERAL_ROLES,
      roles: NCRM_DATA_PROTECTION_ROLES,
      roleAccessMode: "any",
    },
  },
  {
    path: "/ncrm/email-marketing",
    name: "NcrmEmailMarketing",
    component: PremiumFeatureRoute,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ROLES],
    },
  },
  {
    path: "/ncrm/workflows",
    name: "NcrmWorkflowsHome",
    component: PremiumFeatureRoute,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_WORKFLOWS_ROLES],
    },
  },
  {
    path: "/ncrm/workflows/:workflowId",
    name: "NcrmWorkflowDetails",
    component: PremiumFeatureRoute,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_WORKFLOWS_ROLES],
    },
  },
  {
    path: "/ncrm/contacts",
    name: "NcrmContacts",
    component: NcrmContacts,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ROLES],
    },
  },
  {
    path: "/ncrm/activities",
    name: "NcrmActivities",
    component: NcrmActivities,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ACTIVITIES_ROLES],
    },
  },
  {
    path: "/ncrm/leads",
    name: "NcrmLeadsHome",
    component: NcrmLeadsHome,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_LEADS_ROLES],
    },
  },
  {
    path: "/ncrm/leads/boards/:id",
    name: "NcrmLeadBoard",
    component: NcrmLeadBoard,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_LEADS_ROLES],
    },
  },
  {
    path: "/ncrm/leads/:id",
    name: "NcrmLeadDetails",
    component: NcrmLeadDetails,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_LEADS_ROLES],
    },
  },
  {
    path: "/ncrm/deals",
    name: "NcrmDealsHome",
    component: NcrmDealsHome,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ROLES],
    },
  },
  {
    path: "/ncrm/deals/boards/:id",
    name: "NcrmDealBoard",
    component: NcrmDealBoard,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ROLES],
    },
  },
  {
    path: "/ncrm/deals/:id",
    name: "NcrmDealDetails",
    component: NcrmDealDetails,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ROLES],
    },
  },
  {
    path: "/ncrm/contracts",
    name: "NcrmContractsHome",
    component: NcrmContractsHome,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_CONTRACTS_ROLES],
    },
  },
  {
    path: "/ncrm/contracts/:contractId",
    name: "NcrmContractDetails",
    component: NcrmContractDetails,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_CONTRACTS_ROLES],
    },
  },
  {
    path: "/ncrm/onboarding",
    name: "NcrmOnboardingHome",
    component: NcrmOnboardingHome,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ONBOARDING_ROLES],
    },
  },
  {
    path: "/ncrm/onboarding/boards",
    name: "NcrmOnboardingBoards",
    component: NcrmOnboardingBoard,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ONBOARDING_ROLES],
    },
  },
  {
    path: "/ncrm/onboarding/boards/:productId",
    name: "NcrmOnboardingBoard",
    component: NcrmOnboardingBoard,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ONBOARDING_ROLES],
    },
  },
  {
    path: "/ncrm/onboarding/templates",
    name: "NcrmOnboardingTemplates",
    component: NcrmOnboardingTemplates,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ONBOARDING_ROLES],
    },
  },
  {
    path: "/ncrm/onboarding/:onboardingId",
    name: "NcrmOnboardingDetails",
    component: NcrmOnboardingDetails,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ONBOARDING_ROLES],
    },
  },
  {
    path: "/ncrm/products",
    name: "NcrmProducts",
    component: NcrmProducts,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_ROLES],
    },
  },
  {
    path: "/ncrm/companies/:id",
    name: "NcrmCompanyDetails",
    component: NcrmCompanyDetails,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_CONTACT_DETAILS_ROLES],
    },
  },
  {
    path: "/ncrm/people/:id",
    name: "NcrmPersonDetails",
    component: NcrmPersonDetails,
    props: true,
    meta: {
      requiresAuth: true,
      moduleKey: "crm",
      roles: [...SUPER_ROLES, ...NCRM_CONTACT_DETAILS_ROLES],
    },
  },
  {
    path: "/Recrutare",
    name: "Recrutare",
    component: Recrutare,
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, "vacation-hr", ...RECR_ROLES, ...CRM_ROLES],
    },
  },
  {
    path: "/RecrutareDetails/:id",
    name: "RecrutareDetails",
    component: RecrutareDetails,
    props: true,
  },
  {
    path: "/no-company-context",
    name: "NoCompanyContext",
    component: NoCompanyContext,
    meta: {
      requiresAuth: true,
      requiresCompanyContext: false,
    },
  },
  ...publicAuthRoutes,
];

if (isInternalDemoUiEnabled) {
  routes.push({
    path: "/demoui",
    name: "DemoUi",
    component: () => import("@/components/demoui.vue"),
    meta: {
      requiresAuth: true,
      roles: [...SUPER_ROLES, ...VAC_ROLES, ...CRM_ROLES, ...RECR_ROLES],
    },
  });
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const parsePositiveId = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return Math.trunc(parsed);
};

const resolveCompanyContextId = (session) =>
  session?.companyId || parsePositiveId(localStorage.getItem("user-company-id"));

// Guard-ul global pentru autentificare și autorizare. H3: sesiunea vine din markerul non-secret, nu din JWT.
router.beforeEach((to, from, next) => {
  const session = readAuthSession();
  if (session && (session.invalid || isAuthSessionExpired(session))) {
    clearAuthStorage();
    if (to.meta?.publicAuth) {
      return next();
    }
    return next("/login");
  }
  const signedIn = Boolean(session);
  const tokenPayload = session?.tokenPayload || null;
  const legacyRole = normalizeRoleKey(localStorage.getItem("user-role"));
  const primaryRole = normalizeRoleKey(localStorage.getItem("user-primary-role")) || legacyRole;
  let storedRoleKeys = [];
  try {
    const raw = localStorage.getItem("user-roles");
    if (raw) {
      const parsed = JSON.parse(raw);
      storedRoleKeys = Array.isArray(parsed)
        ? parsed
            .map((entry) => {
              if (!entry) return null;
              if (typeof entry === "string") return normalizeRoleKey(entry);
              return normalizeRoleKey(entry.key || entry.role || entry.name);
            })
            .filter(Boolean)
        : [];
    }
  } catch (err) {
    // fallback silent
    storedRoleKeys = [];
  }

  const roleKeysSet = new Set(storedRoleKeys);
  if (primaryRole) roleKeysSet.add(primaryRole);
  if (legacyRole) roleKeysSet.add(legacyRole);

  const aliasSet = new Set();
  roleKeysSet.forEach((rk) => expandRoleAliases(rk).forEach((alias) => aliasSet.add(alias)));
  const licenseSnapshot = readStoredLicenseSnapshot(tokenPayload);
  const hasAdminBypass = roleKeysSet.has("admin") || aliasSet.has("admin");
  const companyContextId = resolveCompanyContextId(session);
  const requiresCompanyContext = Boolean(to.meta?.requiresAuth) && to.meta?.requiresCompanyContext !== false;
  const redirectUnauthorized = () => {
    const defaultCount = storedRoleKeys.filter((rk) => DEFAULT_ROLE_KEYS.includes(rk)).length;
    if (defaultCount > 1) {
      return next("/");
    }
    const preferredModuleId = localStorage.getItem("home-default-module");
    const redirectPath = resolveRedirectPath(storedRoleKeys, primaryRole || legacyRole, {
      preferredModuleId,
      licenseSnapshot,
    });
    if (redirectPath === to.path) {
      const fallbackPath = resolveRedirectPath(storedRoleKeys, primaryRole || legacyRole, {
        licenseSnapshot,
      });
      if (fallbackPath === to.path) {
        return next("/");
      }
      return next(fallbackPath);
    }
    return next(redirectPath);
  };

  if (to.path === "/" && !signedIn) {
    return next("/login");
  }
  if (to.meta.requiresAuth && !signedIn) {
    return next("/login");
  }
  if (to.name === "NoCompanyContext" && (hasAdminBypass || companyContextId)) {
    const preferredModuleId = localStorage.getItem("home-default-module");
    const redirectPath = resolveRedirectPath(storedRoleKeys, primaryRole || legacyRole, {
      preferredModuleId,
      licenseSnapshot,
    });
    return next(redirectPath || "/");
  }
  if (requiresCompanyContext && !hasAdminBypass && !companyContextId) {
    if (to.name === "NoCompanyContext") {
      return next();
    }
    return next({ name: "NoCompanyContext" });
  }
  if (
    to.meta?.moduleKey &&
    !canAccessModule(to.meta.moduleKey, {
      roleKeys: Array.from(roleKeysSet),
      licenseSnapshot,
      fallbackIfUnknown: true,
    })
  ) {
    if (to.path === "/") {
      return next();
    }
    const preferredModuleId = localStorage.getItem("home-default-module");
    const redirectPath = resolveRedirectPath(storedRoleKeys, primaryRole || legacyRole, {
      preferredModuleId,
      licenseSnapshot,
    });
    return next(redirectPath === to.path ? "/" : redirectPath);
  }
  const allowedLiteral = (to.meta?.literalRoles || []).map((r) => normalizeRoleKey(r)).filter(Boolean);
  const hasLiteralRoleRequirement = allowedLiteral.length > 0;
  const hasLiteralRole = hasLiteralRoleRequirement
    ? allowedLiteral.some((role) => roleKeysSet.has(role))
    : false;

  const allowedRoles = (to.meta?.roles || []).map((r) => normalizeRoleKey(r)).filter(Boolean);
  const hasRoleRequirement = allowedRoles.length > 0;
  const hasRole = hasRoleRequirement
    ? allowedRoles.some((role) => roleKeysSet.has(role) || aliasSet.has(role))
    : false;

  if (to.meta?.roleAccessMode === "any") {
    if ((hasLiteralRoleRequirement || hasRoleRequirement) && !hasLiteralRole && !hasRole) {
      return redirectUnauthorized();
    }
  } else {
    if (hasLiteralRoleRequirement && !hasLiteralRole) {
      return redirectUnauthorized();
    }
    // Enhanced authorization block to prevent infinite loops for "caller"
    if (hasRoleRequirement && !hasRole) {
      return redirectUnauthorized();
    }
  }
  next();
});

export default router;
export { normalizeRoleKey, expandRoleAliases, resolveRedirectPath };
